import React from 'react';
import cx from 'classnames';
import { SLDSTooltip } from '@salesforce/design-system-react';

function Tooltip({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSTooltip, Object.assign({}, props, {
    className: cx(className, "tds-toast")
  }));
}
Tooltip.displayName = "Tooltip";
Tooltip.propTypes = SLDSTooltip.propTypes;
Tooltip.defaultProps = SLDSTooltip.defaultProps;

export { Tooltip as default };
